<template>
    <div :style="{backgroundColor:layout?.pageBackground?.color}">
        <!-- Banner Section -->
        <section class="layout_two_banner" v-if="layout">
            <!-- <h1>Modern Banner Design</h1>
            <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                when an unknown printer took a galley of type and scrambled
            </p>
            <button class="btn">JOIN US</button> -->
            <img v-if="layout.box1.image.preview" :src="layout.box1.image.preview" alt="Banner Image"
                class="main-image banner-image" />
        </section>

        <!-- Pricing Section -->
        <section class="layout_two_pricing" v-if="layout">
            <h2 class="custom-heading" :style="{
                fontSize: layout.box2.heading.fontSize + 'px',
                color: layout.box2.heading.color,
                // backgroundColor: layout.box2.heading.backgroundColor,
                fontFamily: layout.box2.heading.fontFamily,
                fontWeight: layout.box2.heading.bold ? 'bold' : 'normal'
            }">{{ layout.box2.heading.text }}</h2>

            <table class="layout_two" :style="{
                border: '2px solid ' + layout.box2.tableStyle.borderColor,
                fontSize: layout.box2.tableStyle.fontSize + 'px',
                fontFamily: layout.box2?.tableStyle?.fontFamily
            }">
                <thead>
                    <tr :style="{
                        backgroundColor: layout.box2?.tableStyle?.headerBg,
                        color: layout.box2?.tableStyle?.headerColor,
                        fontWeight: layout.box2?.tableStyle?.bold ? 'bold' : 'normal'
                    }">
                        <th :style="{
                            border: '1px solid ' + layout.box2.tableStyle.borderColor
                        }">Title</th>
                        <th :style="{
                            border: '1px solid ' + layout.box2.tableStyle.borderColor
                        }">Price</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in layout.box2?.tableData" :key="index" :style="{
                        backgroundColor: layout.box2.tableStyle.cellBg,
                        color: layout.box2.tableStyle.cellColor,
                        border: '1px solid ' + layout.box2.tableStyle.borderColor
                    }">
                        <td :style="{
                            border: '1px solid ' + layout.box2.tableStyle.borderColor
                        }">{{ item.service }}</td>
                        <td :style="{
                            border: '1px solid ' + layout.box2.tableStyle.borderColor
                        }">{{ item.price }}</td>
                    </tr>
                </tbody>
            </table>
        </section>

        <!-- Quote Request Section -->
       <section class="quote-box">
            <div class="quote-content" :style="{
                fontSize: layout.box3?.textWithLink?.fontSize + 'px',
                color: layout.box3?.textWithLink?.color,
                fontFamily: layout.box3?.textWithLink?.fontFamily,
                backgroundColor: layout.box3?.textWithLink?.backgroundColor,
                fontWeight: layout.box3?.textWithLink?.bold ? 'bold' : 'normal'
            }" v-if="layout.box3?.textWithLink?.text" v-html="processQuoteLink(layout.box3.textWithLink.text)">
            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: "PageLayoutTwo",
    props: {
        layout: Object
    },

    methods: {
		processQuoteLink(content) {
            if (!content || !this.layout?.box3?.textWithLink?.linkText) return content;

            const linkText = this.layout.box3.textWithLink.linkText;
            let url = this.layout.box3.textWithLink.linkUrl || '/quote-default';
            
            // Check if URL starts with http:// or https://
            if (!url.startsWith('http://') && !url.startsWith('https://')) {
                // If it doesn't start with / either, make it absolute from root
                if (!url.startsWith('/')) {
                    url = '/' + url;
                }
            }
            
            const color = this.layout.box3.textWithLink.linkColor || '#007bff';
            const regex = new RegExp(`\\b${linkText}\\b`, 'gi');
            return content.replace(regex, `<a href="${url}" style="color: ${color}; text-decoration: underline;">${linkText}</a>`);
        },
	}
}
</script>

<style>
/* === BANNER SECTION === */
/* .layout_two_banner {
    background-color: #2b2b2b;
    background-image: radial-gradient(circle at center, rgba(0, 0, 0, 0.1) 1px, transparent 1px),
        repeating-linear-gradient(135deg, rgba(255, 255, 255, 0.05) 0, rgba(255, 255, 255, 0.05) 1px, transparent 2px, transparent 10px);
    background-size: cover;
    background-repeat: repeat;
    padding: 100px 20px;
    text-align: center;
    color: white;
} */

.layout_two_banner h1 {
    font-size: 48px;
    font-weight: bold;
    margin: 0 0 20px;
}

.layout_two_banner p {
    max-width: 800px;
    margin: 0 auto 40px;
    font-size: 16px;
    line-height: 1.6;
    color: #ccc;
}

.layout_two_banner .btn {
    /* background-color: #e0e0e0; */
    color: #000;
    padding: 15px 40px;
    font-size: 18px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.layout_two_banner .btn:hover {
    background-color: #c0c0c0;
}

/* === PRICING TABLE SECTION === */
.layout_two_pricing {
    padding: 80px 20px 0px;
    text-align: center;
    /* background-color: #f2f2f2; */
}

.layout_two_pricing h2 {
    font-size: 48px;
    font-weight: bold;
    margin-bottom: 60px;
}

table.layout_two {
    margin: 0 auto;
    /* border-collapse: collapse; */
    width: 90%;
    max-width: 700px;
    /* background-color: white; */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}

.layout_two th,
.layout_two td {
    padding: 15px;
    /* border: 1px solid #000; */
    text-align: left;
}

/* .layout_two th {
    background-color: #111;
    color: white;
    font-size: 20px;
} */

.layout_two td {
    font-weight: bold;
    text-transform: uppercase;
    width: 50%;
}

/* === QUOTE BOX SECTION === */
.quote-box {
    padding: 80px 20px;
    /* background-color: #f2f2f2; */
    display: flex;
    justify-content: center;
    align-items: center;
}

.quote-content {
    background-color: #eee;
    padding: 60px 60px;
    border-radius: 30px;
    max-width: 400px;
    text-align: center;
    font-size: 25px;
    line-height: 1.6;
}

.quote-content strong {
    font-weight: bold;
}

.banner-image {
    width: 100%;
    object-fit: cover;
    border-radius: 4px;
    min-block-size: auto;
    min-height: 300px;
    max-height: 400px;
}

@media (max-width : 768px) {
    .banner-image {
        min-height: auto;
    }

    .layout_two_pricing .custom-heading {
        font-size: 23px !important;
    }

    .layout_two_pricing,
    .quote-box {
        padding: 40px 20px;
    }

    .layout_two {
        font-size: 14px !important;
    }

    .quote-content {
        padding: 30px 30px;
    }

}
</style>
